import React, { AriaRole } from 'react';
import { useSelector } from 'react-redux';
import { IconPhotoCameraOutline, IconPhotoCameraFill } from '@saucelabs/ds-icons';

import selectors from '../selectors';
import GenericPopover from './GenericPopover';
import GenericButton from './GenericButton';
import { ImageInjectionPopover } from '../../imageInjection';

const CameraUploadButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const {
    deviceToolsDisabled,
  } = useSelector(selectors.toolbarButtonSelector);

  return (
    <GenericPopover
      trigger={(
        <GenericButton
          dataQa="live-session-toolbar-camera-upload-button"
          disabled={deviceToolsDisabled}
          icon={IconPhotoCameraOutline}
          iconHightlight={IconPhotoCameraFill}
          isPopoverTrigger
          label="Camera Upload"
          role={role || 'menuitem'}
        />
      )}
    >
      <div data-prevent-toolbar-overlay-close>
        <ImageInjectionPopover />
      </div>
    </GenericPopover>
  );
};

CameraUploadButton.displayName = 'CameraUploadButton';

export default CameraUploadButton;
